import IExternalEnumerationProvider from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/services/external-enumeration-provider";

import { getFVManifests } from "../../../app/slices/fachverfahren/selectors";
import { ModulFState } from "../../../app/slices/store";

/**
 * Ein Provider für externe Enumerationen, mit deren Hilfe die Form/OverviewEngine IDs in Labels auflösen kann.
 * Momenten unterstützen wir hier nur die Enumeration für den Namen installierter Fachverfahren.
 */
export function externalEnumProvider(store: ModulFState): IExternalEnumerationProvider {
	return source => {
		switch (source) {
			case "fachverfahren":
				return (getFVManifests(store) ?? [])
					.map(it => ({ [it.identification.id]: { de: it.identification.shortName } }))
					.reduce((prev, cur) => ({ ...prev, ...cur }), {});
			case "generierteDokumente":
				return {}; // TODO findme wie an die erzeugtenDokumente kommen?
			default:
				return {};
		}
	};
}
